<div class="weight-chart-container">
  <app-loading *ngIf="showLoading"></app-loading>
  <div class="weight-chart-nav-bar box">
    <div class="weight-chart-nav-bar-title">وزن</div>
    <div class="weight-chart-back" (click)="back()">
      <img src="assets/general/back-blue.svg" />
    </div>
  </div>
  <div class="weight-chart-holder box">
    <div class="weight-bar-chart-container">
      <div class="segment-control-container">
        <div class="selected-segment" id="selected-segment"></div>
        <div
          class="monthly-segment-title"
          id="segment2"
          (click)="segmentSelected(2)"
        >
          ماهانه
        </div>
        <div
          class="weekly-segment-title"
          id="segment1"
          (click)="segmentSelected(1)"
        >
          هفتگی
        </div>
      </div>
      <div class="calendar-holder">
        <div class="calendar-previous-days img-holder" (click)="previousDays()">
          <img src="assets/plan/previousDay.png" />
        </div>
        <div class="calendar-current-days-title">{{ title }}</div>
        <div
          *ngIf="page < 0"
          class="calendar-next-days img-holder"
          (click)="nextDays()"
        >
          <img src="assets/plan/nextDay.png" />
        </div>
      </div>
      <div class="weight-bar-chart-holder">
        <app-line-chart [input]="lineChartInput"></app-line-chart>
      </div>
    </div>
    <div class="weight-chart-cell box" style="border-top: 1px solid #cccccc">
      <div class="weight-chart-cell-title">آخرین وزن وارد شده</div>
      <div class="weight-chart-cell-unit-holder">
        <div class="weight-chart-cell-amount">{{ lastWeight }}</div>
        <div class="weight-chart-cell-unit">کیلوگرم</div>
      </div>
    </div>
    <div class="weight-chart-cell box">
      <div class="weight-chart-cell-title">وزن ایده‌آل</div>
      <div class="weight-chart-cell-unit-holder">
        <div class="weight-chart-cell-amount">{{ idealWeight }}</div>
        <div class="weight-chart-cell-unit">کیلوگرم</div>
      </div>
    </div>
  </div>
</div>
